import { inputClass, mfgFilterGhostBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import { ManufacturingPricingGapFilter } from "./ManufacturingPricingGapFilter";
import { PricingFacetMultiSelect } from "./PricingFacetMultiSelect";
import type { ManufacturingPricingGridState } from "./useManufacturingPricingGrid";

type Props = {
  grid: ManufacturingPricingGridState;
};

export function ManufacturingPricingGridFilters({ grid }: Props) {
  const g = grid;
  return (
    <div className="flex flex-wrap items-end gap-x-3 gap-y-2">
      <label className="block min-w-[10rem] flex-1 space-y-0.5 text-sm sm:max-w-[14rem]">
        <span className="text-xs text-gray-600 dark:text-zinc-400">Cost scope</span>
        <select
          className={inputClass}
          value={g.filters.plant_id}
          onChange={(e) => g.setFilters((prev) => ({ ...prev, plant_id: e.target.value }))}
          disabled={g.listBusy}
        >
          <option value="">Entire org (base COGS)</option>
          {g.plants.map((p) => (
            <option key={p.id} value={p.id}>
              Plant · {p.plant_code} · {p.name}
            </option>
          ))}
        </select>
      </label>
      <PricingFacetMultiSelect
        label="Group"
        options={g.distinctSeries}
        selected={g.filters.series}
        onChange={(series) => g.setFilters((prev) => ({ ...prev, series }))}
        disabled={g.listBusy}
      />
      <PricingFacetMultiSelect
        label="Style"
        options={g.distinctRoofStyles}
        selected={g.filters.roof_style}
        onChange={(roof_style) => g.setFilters((prev) => ({ ...prev, roof_style }))}
        disabled={g.listBusy}
      />
      <PricingFacetMultiSelect
        label="Size"
        options={g.distinctSizeBands}
        selected={g.filters.size_band}
        onChange={(size_band) => g.setFilters((prev) => ({ ...prev, size_band }))}
        disabled={g.listBusy}
      />
      <ManufacturingPricingGapFilter
        gaps={g.filters.gaps}
        match={g.filters.gap_match}
        disabled={g.listBusy}
        onGaps={(gaps) => g.setFilters((prev) => ({ ...prev, gaps }))}
        onMatch={(gap_match) => g.setFilters((prev) => ({ ...prev, gap_match }))}
      />
      <label className="flex items-center gap-1.5 pb-2 text-xs text-gray-700 dark:text-zinc-300">
        <input
          type="checkbox"
          checked={g.filters.include_material_uses}
          onChange={(e) =>
            g.setFilters((prev) => ({ ...prev, include_material_uses: e.target.checked }))
          }
        />
        Uses
      </label>
      <label className="flex items-center gap-1.5 pb-2 text-xs text-gray-700 dark:text-zinc-300">
        <input
          type="checkbox"
          checked={g.filters.include_named_variants}
          onChange={(e) =>
            g.setFilters((prev) => ({ ...prev, include_named_variants: e.target.checked }))
          }
        />
        Variants
      </label>
      <button
        type="button"
        className={`${mfgFilterGhostBtnClass} mb-0.5`}
        onClick={() =>
          g.setFilters({
            series: [],
            roof_style: [],
            size_band: [],
            plant_id: "",
            include_material_uses: false,
            include_named_variants: false,
            gaps: [],
            gap_match: "and",
            sku_scope: "products",
          })
        }
        disabled={g.listBusy}
      >
        Clear
      </button>
    </div>
  );
}
